import {
  SessionStats,
  initialSessionStats,
} from 'src/replicant/stats/stats.ruleset';

// Session storage for stats
export const sessionStats: Record<SessionStats, number> = {
  ...initialSessionStats,
};

/**
 * Increment session(temporary) stats of user activity
 */
export function incrementSessionStat(id: SessionStats): void {
  if (!sessionStats[id]) sessionStats[id] = initialSessionStats[id];
  sessionStats[id] += 1;
}

/**
 * Set session stats of user activity
 */
export function setSessionStat(id: SessionStats, value: number): void {
  sessionStats[id] = value;
}

/**
 * Reset session stats of user activity
 */
export function resetSessionStat(id: SessionStats): void {
  setSessionStat(id, initialSessionStats[id]);
}

/**
 * Reset all session stats of user activity
 */
export function resetAllSessionStats(): void {
  for (const key of Object.keys(initialSessionStats) as SessionStats[]) {
    resetSessionStat(key);
  }
}
